export default "__VITE_ASSET__Bepg_epA__"